module.exports = __webpack_public_path__ + "static/media/icone-viewer-azul.209e4ef6.svg";